import { checkForFreezeFunctionality,isAllShareAllPool } from "./commonUtil";



const FLOW_CHECKER = "RAE";
export function disabledValidator(accData) {
  let isAllShareAllPoolStatus = isAllShareAllPool();
  return checkForFreezeFunctionality().indexOf(FLOW_CHECKER) !== -1
    ? true
    : false || accData.availableBalance === 0
    ? true
    : false || isAllShareAllPoolStatus
    ? true
    : false || accData.roleAccess === "Read Only"
    ? true
    : false ;
}

export function disabledText1(accData) {
  let isAllShareAllPoolStatus = isAllShareAllPool();
  return checkForFreezeFunctionality().indexOf(FLOW_CHECKER) !== -1
    ? 'Transactions for this account are frozen. Contact us at 888-383-4483 or donorservice@vanguardcharitable.org'
    : '' || accData.availableBalance === 0
    ? 'This account has $0.00 available balance. Exchange transaction cannot continue.'
    : '' || isAllShareAllPoolStatus
    ? 'A grant has been recommended to close the account.Exchanges cannot be submitted.'
    : '' || accData.roleAccess === "Read Only"
    ? 'You are unable to recommend exchanges on this account. If you believe this is an error, please contact us at 888-383-4483.'
    : '' ;
}
